import React from 'react';
import TextButton, { Size as TextButtonSize, ContentType as TextButtonContentType } from '@uds/text-button';

import { RecursiveShortcodeProps } from './Shortcode';

const PhoneNumber = ({ RecursiveShortcode, attributes, elements, against, ...rest }: RecursiveShortcodeProps) => {
  return (
    <TextButton
      href={`tel:${attributes?.number}`}
      id={attributes?.analyticskey ? `shortcode-tel-${attributes?.analyticskey}` : ''}
      contentType={TextButtonContentType.PHONE_NUMBER}
      size={TextButtonSize.INHERIT}
    >
      {/* @ts-ignore: error when upgrading to @ux/config */}
      <RecursiveShortcode elements={elements} {...rest} />
    </TextButton>
  );
};

PhoneNumber.displayName = 'PhoneNumber';

export default PhoneNumber;
